angular
  .module 'bookAndPay'
  .directive 'expireWarningMessage', ->
    restrict: 'EA'
    scope:
      cart: '='
    template: require('templates/book_and_pay/expire_warning_message.html.slim')
    controller: ($scope, $interval, BookAndPayService) ->
      getMinutesLeft = ->
        minutes = moment($scope.cart.expires_at).diff(moment(), 'minutes')
        $scope.visible = minutes < 6
        if minutes < 1
          return 1
        minutes

      $scope.minutesLeft = getMinutesLeft()

      intervalId = $interval () ->
        BookAndPayService.isExpired($scope.cart, true)
        $scope.minutesLeft = getMinutesLeft()
      , 1000

      $scope.$on '$destroy', () ->
        $interval.cancel intervalId
